import { Button, Grid } from "@mui/material";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { Content } from "@/components/content/Content";
import CreateOrEdit from "@/controller/CreateOrEdit";
import WithSave from "@/controller/WithSave";
import { InfoTypeResponseDto } from "@/gen/api/securefile";
import { OdResourcePageProps } from "@/types/resource";
import { push } from "connected-react-router";
import InfoTypeEditor from "@/components/securefiles/InfoTypeEditor";
import { useDefaultSavedHandlers } from "@/controller/defaultSavedHandlers";
import usePermitGuard from "@/authProvider/usePermitGuard";
import { MANAGE_FILE_CLASSIFICATION_AND_PROTECTION_RULES } from "@/constants";
import { CollectEditsProtocol } from "@/utils/zustand-form/ext/collectEdits";
import { FormNode, useCreateZTreeStore, ZTreeStoreProvider } from "@/utils/zustand-form";
import { useStore } from "zustand";




const CreateInfoType: FC<OdResourcePageProps> = (props) => {
  usePermitGuard([[MANAGE_FILE_CLASSIFICATION_AND_PROTECTION_RULES]])

  return (
    <CreateInfoTypeBody {...props} />
  )
}

const CreateInfoTypeBody: FC<OdResourcePageProps> = ({
  options, resource,
}) => {
  const dispatch = useDispatch()

  const zstore = useCreateZTreeStore()

  const handleSave = (save: (record:any,callbacks?:any)=>Promise<InfoTypeResponseDto>) => async () => {
    try {
      // Use CollectEditsProtocol to collect data from zustand store
      const payload = await CollectEditsProtocol.invoke(
        (protocol) => zstore.getState().invokeNodeProtocol('root', protocol) as any
      );

      const data = await save(payload)
      dispatch(push(`/${resource}/${data.id}/show`))
    } catch (error) {
      return
    }
  }
  const dirty = useStore(zstore, state => {
    let hasChanges = Object.values(state.getNode('root')?.state.touched ?? {}).some(x => x)
    if (hasChanges) { return true }
    state.traverseDescendants('root', (next) => {
      let childNode : FormNode|null = null 
      while (!hasChanges && (childNode = next())) {
        hasChanges = Object.values(childNode.state.touched).some(x => x)
      }
    })
    return hasChanges
  })

  const handlers = useDefaultSavedHandlers("Create File Info Type")

  return (
    <Content
      pageName="Create File Info Type"
      resourceName="Create"
      breadcrumbs={[...(options?.breadcrumbs ?? []),
        { label: 'File Info Types', path: `/${resource}` }
      ]}
      mainActions={
        <>
          <CreateOrEdit resource={resource} basePath="" {...handlers}>
            <WithSave async
              render={({save, saving}) => 
                <Button color="primary" variant="contained"
                  disabled={saving || !dirty}
                  onClick={handleSave(save)}
                >
                  Save
                </Button>}
            />
          </CreateOrEdit>
          <Button color="primary" variant="outlined" component={RouterLink}
            to={`/${resource}`}
          >
            Cancel
          </Button>
        </>
      }
    >
      <Grid container spacing={4} sx={{ mt: 2 }} >
        <Grid item xs={12}>
          <ZTreeStoreProvider value={zstore}>
            <InfoTypeEditor title="New File Info Type" />
          </ZTreeStoreProvider>
        </Grid>
      </Grid>
    </Content>
  )
}

export default CreateInfoType;
